import { Page } from '@/shared/api/pagination';
import type {
  CreateTQLQuery,
  TQLQuery,
  TQLQueryBrief,
  UpdateTQLQuery,
} from '@/entities/srm/tql-query';
import type { AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

const defaultOptions = {
  baseURL: '/api/srm/v4',
};
export class TQLQueriesApi {
  static getTQLQueries(options?: AxiosRequestConfig) {
    return srmInstance.get<Page<TQLQueryBrief>>(`/query`, {
      ...options,
    });
  }

  static getTQLQuery(queryName: string, options?: AxiosRequestConfig) {
    return srmInstance.get<TQLQuery>(`/query/${queryName}`, {
      ...defaultOptions,
      ...options,
    });
  }

  static getSearchConditionOperators(options?: AxiosRequestConfig) {
    return srmInstance.get(`/tql/operators/search`, {
      ...defaultOptions,
      ...options,
    });
  }

  static deleteTQLQuery(queryName: string, options?: AxiosRequestConfig) {
    return srmInstance.delete(`/query/${queryName}`, {
      ...defaultOptions,
      ...options,
    });
  }

  static createTQLQuery(payload: CreateTQLQuery, options?: AxiosRequestConfig) {
    return srmInstance.post<TQLQuery>(`/query`, payload, {
      ...defaultOptions,
      ...options,
    });
  }

  static updateTQLQuery(
    queryName: string,
    payload: UpdateTQLQuery,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.put<TQLQuery>(`/query/${queryName}`, payload, {
      ...defaultOptions,
      ...options,
    });
  }
}